import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

// Director returns pending notes to the stage manager with an optional reason.
export default function ReturnDialog({ open, onOpenChange, onConfirm, busy }) {
  const [reason, setReason] = useState("");
  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) setReason(""); }}>
      <DialogContent data-testid="notes-return-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Return for changes?</DialogTitle>
          <DialogDescription>The stage manager is notified and can edit and resubmit these notes.</DialogDescription>
        </DialogHeader>
        <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="What should they change? (optional)" data-testid="notes-return-reason" />
        <DialogFooter>
          <Button disabled={busy} onClick={() => onConfirm(reason)} className="rounded-full bg-red-600 hover:bg-red-700" data-testid="notes-return-confirm">Return notes</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
